'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useHistory } from 'react-router-dom';

export default function ScrollToTop() {
  const pathname = usePathname();
  const history = useHistory();

  useEffect(() => {
    if (window.location.hash) return;
    if (history.action === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, history]);

  return null;
}
